//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setInstoreOrderPageNumber } from "../../features/instoreOrders/instoreOrdersSlice";
import { InstoreOrder } from "../../models/instoreOrder";
import { MetaData } from "../../models/pagination";
import InstoreOrdersTableHeader from "./InstoreOrdersTableHeader";
import InstoreOrdersTableRow from "./InstoreOrdersTableRow";
import useAdminManager from "../../hooks/useAdminManager";
import MainTable from "../_layout/MainTable";
//#endregion

//#region INTERFACE
interface Props {
  changeOrderStatusHandler: (
    instoreOrder: InstoreOrder,
    status: string
  ) => void;
  deleteHandler: (item: InstoreOrder) => void;
  itemsLoaded: boolean;
  metaData?: MetaData;
  items: InstoreOrder[];
  hide?: boolean;
}
//#endregion

export default function InstoreOrdersTable({
  changeOrderStatusHandler,
  deleteHandler,
  itemsLoaded,
  metaData,
  items,
  hide = false,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.account);

  // Roles
  const isAdmin = useAdminManager(user);
  //#endregion
  

  return (
    <MainTable
      itemsLoaded={itemsLoaded}
      metaData={metaData}
      onPageChangeHandler={(page: number) =>
        dispatch(setInstoreOrderPageNumber({ page: page }))
      }
      header={<InstoreOrdersTableHeader isAdmin={isAdmin} />}
      hide={hide}
    >
      {items.map((instoreOrder) => (
        <InstoreOrdersTableRow
          changeOrderStatusHandler={(
            instoreOrder: InstoreOrder,
            status: string
          ) => changeOrderStatusHandler(instoreOrder, status)}
          deleteHandler={() => deleteHandler(instoreOrder)}
          isAdmin={isAdmin}
          instoreOrder={instoreOrder}
          key={instoreOrder.id}
        />
      ))}
    </MainTable>
  );
}
